require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-coding-for-social-good-applying-a-career-in-social-work-to-mobile-app-development.json") })
        }
      }, "path---blog-coding-for-social-good-applying-a-career-in-social-work-to-mobile-app-development");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-coding-for-social-good-applying-a-career-in-social-work-to-mobile-app-development!./.cache/json/blog-coding-for-social-good-applying-a-career-in-social-work-to-mobile-app-development.json
// module id = 779
// module chunks = 231608221292675